<!--基于v-charts和echarts的折线图-->
<template>
  <ve-line
    height="100%"
    :data="chartData"
    :settings="setting"
    :extend="chartExtends"
    :loading="loading"
    :data-empty="data.length ? false : true"
  />
</template>
<script>
export default {
  props: {
    columns: {
      type: Array,
      default: () => { return [] }
    },
    data: {
      type: Array,
      default: () => { return [] }
    },
    setting: {
      type: Object,
      default: () => { return {} }
    },
    extend: {
      type: Object,
      default: () => { return {} }
    },
    loading: {
      type: Boolean,
      default: false
    },
    unit: {
      type: Object,
      default () {
        return {}
      }
    },
    format: {
      type: Array,
      default () {
        return ['yyyy-MM-dd hh:mm']
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
    chartData () {
      return {
        columns: this.columns,
        rows: this.data
      }
    },
    chartExtends () {
      const extend = this.extend || {}
      const option = {
        grid: {
          left: 50,
          right: 50
        },
        xAxis: {
          axisLabel: {
            formatter: (value) => {
              return this.$parseTime(value, this.format[0])
            }
          }
        },
        tooltip: {
          formatter: (params) => {
            let html = this.$parseTime(params[0].name, this.format[0])
            for (let i = 0; i < params.length; i++) {
              const { marker, seriesName, data } = params[i]
              const unitInfo = this.unit[seriesName]
              html += `<div>
                        ${marker} 
                        ${unitInfo.label}: ${Number(data[1]).toFixed(2)}${unitInfo.unit}  
                      </div>`
            }
            return html
          }
        }
      }
      Object.assign(option, extend)
      return option
    }
  },
  watch: {
    data: {
      handler: function (val) {
        this.chartData.rows = val
      },
      deep: true
    },
    columns (val) {
      this.chartData.columns = val
    }
  }
}
</script>
<style lang="stylus" scoped>
/deep/.v-charts-data-empty
  background-color: #1C2550
  color #1cc197
  font-size 16px
.chart
  height 100%
  width 100%
</style>
